import { render, staticRenderFns } from "./OrderInfoPage.vue?vue&type=template&id=25b5e99a&"
import script from "./OrderInfoPage.vue?vue&type=script&lang=js&"
export * from "./OrderInfoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports